module.exports = __webpack_public_path__ + "static/media/2.22.0c41eda4.png";